import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useState } from 'react';
import { OnboardingForm } from '../components/onboarding-form.component';
import { defaultKey, onboardingTopics } from '../components/onboarding-topics.component';

export const BecomeArtist = (() => {

    const [currentKey, setCurrentKey] = useState(defaultKey);

    function nextKey() {
        const keys = Object.keys(onboardingTopics);
        const i = keys.indexOf(currentKey);
        const next = keys[(i + 1) % keys.length];
        setCurrentKey(next);
    }

    function previousKey() {
        const keys = Object.keys(onboardingTopics);
        const i = keys.indexOf(currentKey);
        const previousIndex = (i - 1) < 0 ? (keys.length - 1) - i : (i - 1);
        const previous = keys[previousIndex];
        setCurrentKey(previous);
    }

    return (
        <div className="text-center">

            <div className="text-center">
                <p className="mb-0 text-avenir-ul text-300">
                    <span className="bg-darker">INTERESTED IN BECOMING A PARTNER?</span>
                </p>
                <span className="p-1 bg-darker text-avenir-re text-primary text-115">Here are some questions you should consider first</span>
            </div>


            <div className="mx-auto mt-5 bg-darker col-10 col-xxl-8">
                <div className="d-flex justify-content-between align-items-stretch">
                    <button className="btn btn-transparent text-light rounded-0" onClick={previousKey}>
                        <FontAwesomeIcon icon="chevron-left" />
                    </button>
                    <div className="w-75 p-4">
                        <h4 className="text-avenir-re text-uppercase border-bottom border-secondary p-2">{currentKey}</h4>
                        <div style={{ minHeight: '300px' }} className="p-4 mx-auto text-muted text-avenir-re text-115 text-start">
                            {onboardingTopics[currentKey]}
                        </div>
                        <div className="mt-5 d-flex justify-content-center">
                            {Object.keys(onboardingTopics).map((k) => (
                                <div key={k} style={{ height: '4px', width: '25px' }} className={`mx-1 ${k === currentKey ? 'bg-light' : 'bg-secondary'}`}></div>
                            ))}
                        </div>
                    </div>
                    <button className="btn btn-transparent text-light rounded-0" onClick={nextKey}>
                        <FontAwesomeIcon icon="chevron-right" />
                    </button>
                </div>
            </div>

            <div className="py-5">
                <div style={{ height: '5px', width: '100px' }} className="mx-auto bg-light my-5"></div>
            </div>

            <div className="mx-auto my-5 bg-darker col-10 col-xxl-8">
                <OnboardingForm />
            </div>
        </div>
    );
});